
// Detecta el entorno automaticamente: en localhost usa la API local (Laragon nginx :8091),
// en cualquier otro host (produccion) usa sospy.org. Asi no hay que cambiar nada para buildear.
const isLocal =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1');

const server = {
    baseURL: isLocal
        ? 'http://localhost:8091/recoleta/s1_recoleta/public/'
        : 'https://sospy.org/s1_recoleta/public/',
    urlProducto: ''
}

export default server;
